import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SalesPublishPage } from '@/features/publish/pages/SalesPublishPage';
import { batchSearchSchema } from '@/features/publish/types/publish.types';

export const Route = createFileRoute('/_auth/publish/sales')({
  validateSearch: batchSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Sales Publish Panel">
      <Suspense fallback={<PageLoader />}>
        <SalesPublishPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
